<div class="modal-header">Add streaming video feed</div>
<div style="margin: 10px">
  <input
    id="searchinput"
    style="width:95% !important"
    class="feeds-search form-control"
    type="text"
    [(ngModel)]="query"
    placeholder="Filter by feed name"
    autofocus
    />
    @if (fmvFeeds.length > 0) {
      <div>
        <table class="table table-striped table-hover" style="margin-top: 10px;">
          <tbody>
            @for (item of fmvFeeds ; track item) {
              <tr>
                <td>
                  <div class="center-table-row-item">{{ item.fmvFeed.getName() }}</div>
                </td>
                <td>
                  <input type="checkbox" [(ngModel)]="item.addedToEntity" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <div class="row" style="margin-top: 10px;">
      <div class="col-lg-3"></div>
      <div class="col-lg-3">
        <button type="button" class="btn btn-danger" style="width: 100px;" (click)="ok()">OK</button>
      </div>
      <div class="col-lg-3">
        <button type="button" class="btn btn-default" style="width: 100px;" (click)="cancel()">Cancel</button>
      </div>
      <div class="col-lg-3"></div>
    </div>
  </div>